"use client";

import React from "react";
import ReadMore from "./ReadMore";

// Use a permissive prop type to avoid strict inference issues across server/client boundaries
type Props = any;

export default function ReadMoreClient(props: Props) {
  return <ReadMore {...props} />;
}
